import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const formFieldsTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "formFields",
};

export interface IFormFieldsTranslations {
  formFields: (typeof formFieldsTranslations)["en"]["formFields"];
}
